// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'crm_data/filters/FilterPlaceho... Remove this comment to see the full error message
import { setupFilterPlaceholderResolver } from 'crm_data/filters/FilterPlaceholderResolver';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'crm_data/flux/connectPromiseSi... Remove this comment to see the full error message
import { connectPromiseSingle } from 'crm_data/flux/connectPromiseSingle';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'crm_data/owners/CurrentOwnerId... Remove this comment to see the full error message
import CurrentOwnerIdStore from 'crm_data/owners/CurrentOwnerIdStore';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'crm_data/setup/SetupData'. Did... Remove this comment to see the full error message
import SetupData from 'crm_data/setup/SetupData';
import * as UsageLoggerRequiredData from '../usage/UsageLoggerRequiredData';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { setupAuthContainer } from '../setup/setupAuthContainer';
import { setupCurrentOwnerContainer } from '../setup/setupCurrentOwnerContainer';
import { setupCurrentTeamsContainer } from '../setup/setupCurrentTeamsContainer';
import { setupJitaContainer } from '../setup/setupJitaContainer';
import { setupLimitsContainer } from '../setup/setupLimitsContainer';
import { setupMyTeamContainer } from '../setup/setupMyTeamContainer';
import { setupScopesContainer } from '../setup/setupScopesContainer';
import { setupUserSettingsStore } from '../setup/setupUserSettingsStore';
import mark from 'crm-fe-perf/timing/mark';
import { enableEarlyCacheReturn } from 'framework-data-schema-resolvers/earlyCacheReturn';
import { getMeasureOptions } from '../utils/getMeasureOptions';
import { createTracker } from 'usage-tracker';
import { REPORTING_TRACKER } from 'reporting-data/constants/usageTracker';
import events from '../../events.yaml';
import { setPrimaryTracker } from 'usage-tracker-container';
import { getAuth } from 'quartz-core/framework/auth/app';
import { AppStart, AppRenderApplicationStart, SetupFetched, SetupLoaded } from 'crm-fe-perf/timing/marks/crm-records-ui/performanceMarks';
import { setupAppCues } from '../setup/setupAppCues';
export const prerenderSetup = async () => {
  mark(AppStart);
  mark(SetupLoaded);
  enableEarlyCacheReturn();
  const measureOptions = getMeasureOptions();
  const reportingTracker = createTracker({
    events
  });
  setPrimaryTracker(reportingTracker, REPORTING_TRACKER);
  const auth = getAuth();
  const fetchCurrentOwnerId = connectPromiseSingle(CurrentOwnerIdStore);
  const ownersPromise = fetchCurrentOwnerId();
  mark(SetupFetched, measureOptions);
  SetupData(auth);
  setupUserSettingsStore(auth);
  setupScopesContainer(auth);
  setupLimitsContainer(auth);
  setupCurrentTeamsContainer(auth);
  setupMyTeamContainer(auth);
  setupAppCues(auth);
  CrmLogger.init(UsageLoggerRequiredData.get());
  const [ownerId] = await Promise.all([ownersPromise]);
  setupCurrentOwnerContainer(auth, ownerId);
  setupFilterPlaceholderResolver(ownerId);
  setupJitaContainer(auth, ownerId);
  setupAuthContainer(auth);
  mark(AppRenderApplicationStart, measureOptions);
};